export enum errorMessages {
  'cellphone_exists' = 'A contact with this Cellphone Number already exists. ' +
    'Please use a different Cellphone Number or update the existing contact.',
  'user_exists' = 'User already exists.',
  'username_exists' = 'Username Already Exists Please Choose Another One',
}
